import { Box } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import cssVars from '../../styles/vars.module.scss'

const BrandCard = ({ img, link, label }) => {
    return (
        <Link href={link}>
            <Box p="10px" borderRadius={cssVars.radius} border={`1px solid ${cssVars.lightGray}`} sx={{ ":hover": { boxShadow: cssVars.shadow } }}>
                <Box paddingBottom="100%" position="relative"
                    sx={{
                        backgroundImage: `url(${img})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        filter: { md: "grayscale(1)" },
                        ":hover": {
                            filter: 'unset',
                        }
                    }} >
                </Box>
            </Box>
        </Link>
    );
}

export default BrandCard;